

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import tippy from 'tippy.js';

@Component
export default class SearchBox extends Vue {

  pendingDebounce:number = 0;

  @Prop({ default: '',  type: String}) searchTerm!: string;
  @Prop({ default: '',  type: String}) toolTip!: string;

  curSearchTerm:string = '';

  mounted() {
    tippy('[data-tippy-content]');
  }

  onInput(newSearchTerm:string) {

    clearTimeout(this.pendingDebounce);
    this.pendingDebounce = setTimeout(() => this.emitUpdate(newSearchTerm), 300);
  }

  emitUpdate(newSearchTerm:string) {
    this.$emit('search', newSearchTerm);
  }
  
}

